import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNGConfigService } from '@shared/services/prime-ngconfig.service';
import { UiService } from '@shared/services/ui.service';
// import { ThemeSelectorComponent } from './components/theme-selector/theme-selector.component';
import { environment } from '../environments/environment';
import { ToastModule } from 'primeng/toast';
import { GrecaptchaService } from './services/grecaptcha.service';
import { PmAppDisabledDialogComponent } from './components/pm-app-disabled-dialog/pm-app-disabled-dialog.component';
import { MatomoService } from './services/matomo.service';

import { PmCookiesDialog } from './components/pm-cookies-dialog/pm-cookies-dialog';
import { CookiesInitService } from './services/cookies-init.service';
import {
  LocalStorageService,
  LOCAL_STORAGE_ITEMS,
} from '@shared/services/local-storage.service';
import { CommonModule, isPlatformServer } from '@angular/common';
import { TiktokService } from './services/tiktok.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ToastModule,
    PmAppDisabledDialogComponent,
    PmCookiesDialog,
    CommonModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'pm-patient';

  get isDev() {
    let isLocalhost = false;
    if (this.uiService.window?.location) {
      isLocalhost = this.uiService.window?.location?.origin?.includes('4200');
    }
    return !environment.production && isLocalhost;
  }

  get isAppDisabled() {
    return this.uiService.isAppDisabled();
  }

  get isTestMode(): boolean {
    if (isPlatformServer(this.platformId)) return false;
    return this._localStorageService.getItem(LOCAL_STORAGE_ITEMS.TEST_MODE);
  }

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private _cookiesInitService: CookiesInitService,
    private _localStorageService: LocalStorageService,
    private uiService: UiService,
    private primeNGConfigService: PrimeNGConfigService, //IMPORTOWANE ŻEBY SIĘ CONFIG USTAWIŁ
    private _gRechaptchaService: GrecaptchaService,
    private _matomoService: MatomoService,
    private _tiktokService: TiktokService,
  ) {
    this._checkShouldInitMatomo();
  }

  onCookiesSettingsSaved() {
    this._checkShouldInitMatomo();
  }

  private _checkShouldInitMatomo() {
    const analyticsCookiesEnabled =
      this._localStorageService.getItem(
        LOCAL_STORAGE_ITEMS.ANALYTICS_COOKIES_ACCEPTANCE_STATUS,
      ) === true;
    if (analyticsCookiesEnabled) {
      this._matomoService.initScript();
      this._tiktokService.loadScript();
    } else {
      this._matomoService.removeScript();
      this._tiktokService.removeScript();
    }
  }
}
